import * as React from 'react'
import { cn } from '../../lib/utils'

/**
 * Skeleton — a loading placeholder bar. Size and shape it via `className`
 * (e.g. `h-4 w-1/2`, `size-8 rounded-full`, `h-32 w-full rounded-lg`).
 *
 * Adopted from the TailGrids skeleton model (the system our Figma is built on),
 * wired to First Bite tokens. Uses the cool `fbui-neutral-200` gray with the
 * built-in `animate-pulse`. Prefer a skeleton over a spinner whenever the final
 * layout is known (lists, cards, detail panels), and mirror the real content's
 * dimensions so nothing reflows on load.
 *
 * Decorative — rendered `aria-hidden` so screen readers skip it; swap in the
 * real content once it loads.
 */
export const Skeleton = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    aria-hidden="true"
    className={cn('animate-pulse rounded-md bg-fbui-neutral-200', className)}
    {...props}
  />
))
Skeleton.displayName = 'Skeleton'

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>
